import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import base from './base'

Vue.use(Vuex)

export default new Vuex.Store({
  ...base,
  modules: {},
  // 数据保存：window.localStorage
  plugins: [createPersistedState()]
})